import React, { useEffect, useState } from "react";
import { TitleArea } from "../../components/Typography/titleArea";
import TradingViewAdvancedChart from "./component/TradingViewAdvancedChart";
import { StockSelectOptions } from "./component/stockSelectOptions";
import { ChartFilterBar, ChartStyle } from "./component/ChartFilterBar";
import { getTVSymbol } from "../../constants/TradingViewSymbols";
import "../../styles/theme-tokens.css";
import "../../styles/glass-tokens.css";
import "./technicalAnalysis.theme.css";

const TechnicalAnalysis: React.FC = () => {
  const [selectedStock, setSelectedStock] = useState<any>(null);
  const [isDark, setIsDark] = useState<boolean>(() => {
    return localStorage.getItem("darkMode") === "true";
  });
  const [studies, setStudies] = useState<string[]>([]);
  const [chartStyle, setChartStyle] = useState<ChartStyle>("1");

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains("dark"));
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  const tvSymbol = selectedStock?.ticker_symbol
    ? getTVSymbol(selectedStock.ticker_symbol)
    : "CSELK:JKH.N0000";

  return (
    <div className="vi-hm flex md:flex-row flex-col items-center md:items-start w-full select-none">
      <div className="flex flex-col w-full h-full items-start px-4 py-3">
        <TitleArea
          variant="page"
          title="Technical Analysis"
          subTitle="Analyse price trends, momentum, and key technical indicators"
        />
        <hr className="hr-line w-full my-2" />

        <div className="w-full md:w-[500px]">
          <StockSelectOptions
            selectedStock={selectedStock}
            setSelectedStock={setSelectedStock}
          />
        </div>
        <hr className="hr-line w-full my-2" />

        <div className="w-full" style={{ height: "calc(100vh - 250px)" }}>
          <ChartFilterBar
            onIndicatorsChange={setStudies}
            onChartStyleChange={setChartStyle}
            isDark={isDark}
          />
          <TradingViewAdvancedChart
            key={`${
              isDark ? "dark" : "light"
            }-${tvSymbol}-${chartStyle}-${studies.join(",")}`}
            symbol={tvSymbol}
            hideTopToolbar={true}
            hideSideToolbar={true}
            allowSymbolChange={false}
            theme={isDark ? "dark" : "light"}
            backgroundColor={isDark ? "#0F0F0F" : "#FFFFFF"}
            studies={studies}
            chartStyle={chartStyle}
          />
        </div>
      </div>
    </div>
  );
};

export default TechnicalAnalysis;
